import * as AntiForgeryToken from './AntiForgeryToken';

export type AuthTypes = AntiForgeryToken.AntiForgeryTokenTypes;

export default {
  AntiForgeryToken,
};
